/** Short, non-secret fingerprint of a JWT for logs (exp + last chars of signature). */
export function accessTokenLogFingerprint(token: string | undefined): string {
	if (!token) {
		return 'none';
	}

	const parts = token.split('.');
	const suffix = token.slice(-8);
	if (parts.length < 2) {
		return `opaque:…${suffix}`;
	}

	try {
		const padded = parts[1].padEnd(parts[1].length + ((4 - (parts[1].length % 4)) % 4), '=');
		const payload = JSON.parse(atob(padded.replace(/-/g, '+').replace(/_/g, '/'))) as {
			exp?: number;
		};
		const exp =
			typeof payload.exp === 'number'
				? new Date(payload.exp * 1000).toISOString()
				: 'unknown';

		return `exp=${exp} …${suffix}`;
	} catch {
		return `unparsed:…${suffix}`;
	}
}
